import Icon1 from "@assets/icons/Icon";
import React, { useEffect, useState } from "react";
import { colors } from "sexy";
type TextFieldProps = {
  label?: string;
  value?: string;
  mandatory?: boolean;
  noborder?: boolean;
  type?: string;
  mandatory_length?: number | null;
  mandatory_characters?: string[];
  min?: number;
  max?: number | null;
  onChange?: (value: any) => void;
  className?: string;
  autoComplete?: string;
  transparent?: boolean;
  onEnter?: () => void;
  focusOnStart?: boolean;
  disabled?: boolean;
  items?: { label: string }[];
  onSuggestedValue?: (value: any) => void;
  placeholder?: string;
};

export default function TextField(props: TextFieldProps) {
  const {
    label = "",
    value = "",
    mandatory = false,
    noborder = false,
    type = "text",
    min = 0,
    max = null,
    onChange = () => {},
    className = "",
    autoComplete = "off",
    transparent = false,
    onEnter = () => {},
    focusOnStart = false,
    disabled = false,
    items = [],
    onSuggestedValue = () => {},
    placeholder = "",
  } = props;

  const mandatory_length =
    props.mandatory_length !== undefined
      ? props.mandatory_length
      : type === "phone"
        ? 14
        : null;

  const mandatory_characters =
    props.mandatory_characters !== undefined
      ? props.mandatory_characters
      : type === "email"
        ? ["@", "."]
        : [];
  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };
  const [autoFilled, setAutoFilled] = useState(false);
  const [hovering, setHovering] = useState(false);
  // Add state for password visibility
  const [passwordVisible, setPasswordVisible] = useState(false);

  useEffect(() => {
    const input = document.getElementById(`input-${label}`);

    if (input) {
      setTimeout(() => {
        input.style.backgroundColor = "white"; // Ensure background resets
        input.style.transition = "background-color 5000s ease-in-out 0s"; // Prevent instant reset
      }, 100);
    }
  }, []);

  const [focus, setFocus] = useState(false);
  const [suggestedValue, setSuggestedValue] = useState<string>("");

  // Add showPassword function to toggle password visibility
  const showPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  // add a listenner to the enter key and if suggestedValue is not empty, call onSuggestedValue with the suggestedValue
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter" && suggestedValue) {
        onSuggestedValue(suggestedValue);
        setSuggestedValue(""); // Clear suggested value after selection
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [suggestedValue, onSuggestedValue]);

  const handleChange = (ee: any) => {
    let formatted = forceformat(ee.target.value, type);
    let e: any = { ...ee, target: { ...ee.target, value: formatted } };
    onChange(formatted);

    const found = items.find((item) =>
      item.label.toLowerCase().includes(e.target.value.toLowerCase()),
    );

    if (found && e.target.value?.length > 0) {
      setSuggestedValue(found.label as any);
    } else {
      setSuggestedValue("");
    }
  };

  let has_value = value !== null && value !== undefined && value !== "";
  let missing_mandatory_characters = mandatory_characters.some(
    (char) => !value.includes(char) && has_value,
  );
  let mandatory_length_disrespect =
    mandatory_length && value?.length !== mandatory_length && has_value;
  let mandatory_disrespect =
    (mandatory && !value && !focus) ||
    missing_mandatory_characters ||
    mandatory_length_disrespect;
  let border_color = mandatory_disrespect
    ? "outline-red-400"
    : focus
      ? "outline-black"
      : "";

  // Determine the actual input type based on password visibility
  const inputType =
    type === "password"
      ? passwordVisible
        ? "text"
        : "password"
      : type === "phone"
        ? "tel"
        : type;

  return (
    <div className="flex flex-col gap-1 w-full">
      <div className="text-h4 text-neutral-400 ">{label}</div>{" "}
      <div
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className={`w-full min-h-11 h-11 relative flex flex-row select-none ${
          has_value ? "items-end" : "items-center py-1"
        } text-black ${className} 
      w-full
      
      rounded-xl
      ${
        noborder
          ? ""
          : focus
            ? "ring-4 border ring-neutral-300 "
            : mandatory_disrespect
              ? "ring-1 ring-neutral-300 "
              : "border  "
      }
      ${border_color}
      
      ring-none
      transition
      ease-in-out
      duration-150 shadow-sm
      ${
        disabled
          ? "bg-neutral-100 text-shadow_25"
          : transparent
            ? "bg-transparent font-semibold"
            : "bg-white"
      }      
    `}
      >
        {/* {(mandatory_length_disrespect || missing_mandatory_characters) && (
          <div
            className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-400 text-white  text-h6 `}
          >
            Champ invalide
          </div>
        )}
        {mandatory && !has_value && (
          <div
            className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-400 text-white  text-h6 `}
          >
            Champ obligatoire
          </div>
        )} */}
        {!disabled && type != "number" && type != "password" && (
          <div
            onClick={() => handleChange({ target: { value: "" } })}
            className={`absolute  rounded-full py-2 cursor-pointer transition duration-300 top-0.5   ease-in-out right-3 text-gray-300 text-h6 `}
          >
            <Icon1 name="effacer2" size={20} color={colors.neutral_400} />
          </div>
        )}
        {suggestedValue && (
          <div
            onClick={() => {
              onSuggestedValue(suggestedValue);
            }}
            className={`absolute cursor-pointer hover:bg-blue-50 right-2 h-full flex flex-row gap-2 items-center  bg-white justify-center rounded-lg px-2 py-1 text-blue-400 text-h3 `}
          >
            <Icon1 name="entree" size={20} color="#60a5fa" />
            {suggestedValue}
          </div>
        )}
        {type == "password" && (
          <div
            onClick={() => showPassword()}
            className={`absolute  rounded-full py-2  cursor-pointer  ease-in-out top-0.5 right-3 text-gray-300 text-h6 `}
          >
            <Icon1
              name={passwordVisible ? "invisible" : "eye"}
              color="grey"
              size={20}
            />
          </div>
        )}
        <input
          id={`input-${label}`}
          disabled={disabled}
          type={inputType} // Use the dynamically determined type
          min={min}
          max={max !== null ? max : undefined}
          placeholder={placeholder}
          value={value === null ? "" : value}
          autoFocus={focusOnStart}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          autoComplete={autoComplete}
          className={`
          w-full
          bg-transparent
          rounded-xl
          px-3
          h-10
          border-0
          outline-none
          transition
          ease-in-out
          duration-150
        `}
          style={{
            fontSize: "14px",
          }}
        />
      </div>{" "}
    </div>
  );
}

function forceformat(value: string, type: string) {
  if (type === "phone") {
    // Remove all non-numeric characters
    // Add a spaces after every 2 characters
    // Remove any spaces at the end
    // Limit to 14 characters
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})/g, "$1 ")
      .replace(/\s+$/, "")
      .slice(0, 14);
  }
  return value;
}
